import React from 'react';
import { connect } from 'react-redux';
import { Card, CardBody, CardHeader, CardTitle, Form } from 'reactstrap';


class ChangeActive extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      // activity Info
      Status_label: "",
      alert: null,
      header: {},
      url: ""
    };
  }
  componentDidMount() {
    if (this.props.token) {
      this.setState({
        header: {
          headers: {
            'Authorization': `Token ${this.props.token}`
          }
        },
        url: this.props.url,
        userId: this.props.userId,
        companytype: this.props.companytype,
        partnernumber: this.props.partnernumber,
        bgcolor: document.body.classList.contains("white-content")
      });
    }
  }

  componentWillReceiveProps(newProps) {

    if (newProps.token !== this.props.token) {
      this.setState({
        header: {
          headers: {
            'Authorization': `Token ${newProps.token}`
          }
        },
        url: newProps.url,
        companytype: newProps.companytype,
        partnernumber: newProps.partnernumber,
      });
    }
  }

  // to stop the warning of calling setState of unmounted component
  componentWillUnmount() {
    let id = window.setTimeout(null, 0);
    while (id--) {
      window.clearTimeout(id);
    }
  }



  render() {


    return (
      <>
        <div className="content">
          {this.state.alert}
          <Form id="Status">
            <Card>
              <CardHeader className="text-right">
                <CardTitle className="pull-left" tag="h4">Animo Terms and Conditions</CardTitle>
              </CardHeader>
              <CardBody>
                <p style={{ color: this.state.bgcolor ? "black" : "white" }} ><br />
                  <br />A.	Customer will only access and use the Product for its own internal business purposes. Customer shall not resell, sublicense, distribute, allow access to or otherwise provide or make available for any purpose any component of the Product to any person, firm or entity.
                  <br /> B.	Customer will not attempt to disassemble, decompile, or circumvent any technological measure that effectively controls access to, or reverse engineer the Product.
                  <br />C.	Customer will not engage in any conduct designed or intended to interfere with the operation of the Product.
                  <br />D.	Customer will not modify, alter, translate or create derivative works based upon the Product
                  <br />E.	Customer will only access and use the Product for its intended use.
                  <br />F.	Customer will comply with all applicable laws in all jurisdictions in which Customer will use the Product. Customer will not use or allow its employees or agents to use the Product in any jurisdiction where such use is prohibited.
                  <br />G.	The results obtained from the use of the Product are for informational purposes only, and the use of the Product and its results is at customer’s own risk.
                  <br />H.	The Product is provided on an “as is” basis. To the fullest extent permitted by law, all warranties, express or implied, statutory or otherwise, including but not limited to the implied warranties of merchantability, non-infringement of third parties’ rights, and fitness for particular purpose are disclaimed.
                  <br />I.	To the extent allowed by law, neither Animo nor any of its employees, officers, directors, agents, representatives, licensors or suppliers shall be liable for any damages (including, without limitation, incidental and consequential damages, personal injury/wrongful death, lost profits, or damages resulting from lost data or business interruption) resulting from the use of, inability to use or misuse of the Product or its results, whether based on warranty, contract, tort, or any other legal theory, and whether or not customer is advised of the possibility of such damages. In no event shall Third Party Provider’s liability, if any, for the Integrated Products and Results exceed its liability under the its agreement with Avoka.
                  <br />J.	Customer’s right to use the Product may be immediately terminated in the event Customer breaches any material term of this license. Upon any such termination, Customer shall cease use of the Integrated Product.
                  <br />K.	Customer agrees to indemnify, defend and hold Animo, of its employees, officers, directors, agents, representatives, licensors and harmless for, from and against all claims brought by any third party which are attributable to the Customer’s use of the Product.
                  <br />L.	Customer agrees that the proprietary information and know-how, techniques, algorithms, and processes contained in the Product constitute trade secrets of Animo and/or its respective licensors and shall only be used in accordance with the terms of the license. Customer shall use commercially reasonable means to protect such trade secrets.
                  <br />M.	If Customer becomes aware of any actual or threatened activity prohibited by this license it will immediately take all reasonable and lawful measures within its control that are necessary to stop the activity or threatened activity and to mitigate its effects (including, where applicable, by discontinuing and preventing any unauthorized access to the Product and permanently erasing from its systems and destroying any data gained from the unauthorized access, and will notify Animo of any such actual or threatened activity.
                  <br />N.	Animo has the right to monitor Customers use of the Product.
                  <br />O.	Customer agrees that the Product and related Intellectual Property remains the property of Animo and Customer does not have any title or ownership in the Product or the related Intellectual Property.
                  <br />P.	Animo may use, reproduce, distribute and retain all data generated by, submitted to or evaluated utilizing the Product and all other data residing on Animo systems for the purposes of: (a) system and network maintenance and the diagnosis, investigation and/or correction of actual or suspected performance incidents, (b) measurement or evaluation of software, service or system usage or the functionality or performance of the Product, Animo’s systems or internet sites, (c) information security, (d) recommending, developing or monitoring improvements, upgrades or enhancements to the Products, (e) operating the Product or Animo’s systems or internet sites, (f) providing reports to Customer and those parties designated by Customer in writing, (g) responding to Customer requests, (h) analysis, modeling and auditing, and/or (i) compliance with applicable laws, regulations and other legal mandates.
                  <br />Q.	Except as expressly provided, Animo does not obtain any rights in any data input by Customer or the results of Customer’s use of the Product.
                </p>
              </CardBody>

            </Card>

          </Form>
        </div>
      </>
    );
  }
}

const mapStateToProps = state => {
  return {
    obj: [...state.obj],
    token: state.token,
    url: state.url,
    userId: state.userId,
    companytype: state.userPartnerType,
    partnernumber: state.userPartner
  };
};

export default connect(mapStateToProps, null)(ChangeActive);